import { TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH, CHANGE_LAYOUT_TYPE } from './actionTypes'
import {
    LAYOUT_TYPE_FRAMED,
    NAV_STYLE,
    NAV_STYLE_FIXED,
    THEME_COLOR_SELECTION_PRESET,
    THEME_TYPE_LITE
} from './constants'

const initialSettings = {
    navCollapsed: false,
    navStyle: NAV_STYLE_FIXED,
    layoutType: LAYOUT_TYPE_FRAMED,
    themeType: THEME_TYPE_LITE,
    colorSelection: THEME_COLOR_SELECTION_PRESET,

    pathname: '',
    width: window.innerWidth
}

const settings = (state = initialSettings, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                pathname: action.pathname,
                navCollapsed: false
            }
        case TOGGLE_COLLAPSED_NAV:
            return {
                ...state,
                navCollapsed: action.navCollapsed
            }
        case WINDOW_WIDTH:
            return {
                ...state,
                width: action.width
            }
        // case THEME_TYPE:
        //     return {
        //         ...state,
        //         themeType: action.themeType
        //     }
        // case THEME_COLOR_SELECTION:
        //     return {
        //         ...state,
        //         colorSelection: action.colorSelection
        //     }
        //
        case NAV_STYLE:
            return {
                ...state,
                navStyle: action.navStyle
            }
        case CHANGE_LAYOUT_TYPE:
            return {
                ...state,
                layoutType: action.layoutType
            }
        //
        // case SWITCH_LANGUAGE:
        //     return {
        //         ...state,
        //         locale: action.payload
        //     }
        // case HIDE_SIDEBAR:
        //     return {
        //         ...state,
        //         hiddenSidebar: true
        //     }
        // case SHOW_SIDEBAR:
        //     return {
        //         ...state,
        //         hiddenSidebar: false
        //     }
        default:
            return state
    }
}

export default settings
